module.exports = __webpack_public_path__ + "static/img/background.a568162c.svg";